export default __webpack_public_path__ + "static/media/users.c303faa4.svg";